/**
 * Elevio kb-kit uses <a href="https://reactjs.org/docs/context.html" target="_blank">React Context</a> under the hood to provide data to its components.
 *
 * Here is some basic information relating to these contexts.
 *
 * @module
 */
import { createContext } from 'react';
/**
 * This just stores the current search result we are 'looking' at.
 */
const SearchResultContext = createContext(undefined);
SearchResultContext.displayName = 'SearchResultContext';
/**
 * The ArticleContext is set on the article page. It contains the full article details.
 *
 * - It also contains related articles and the parent category.
 */
const ArticleContext = createContext(undefined);
ArticleContext.displayName = 'ArticleContext';
/**
 * Articles related to the currently selected article.
 *
 * - Returns `undefined` if no article is active.
 */
const RelatedArticlesContext = createContext(undefined);
RelatedArticlesContext.displayName = 'RelatedArticlesContext';
/**
 * An ArticleFragment is set when we loop over a list of articles.
 * It contains a subset of the full
 *
 * > **💡 NOTE**: If you use a component / hook that looks up an [[IArticleFragment]] and it doesn't find one but it does find an [[ArticleContext]] then it will use that.
 */
const ArticleFragmentContext = createContext(undefined);
ArticleFragmentContext.displayName = 'ArticleFragmentContext';
/**
 * The Home context contains all the information for rendering the home page.
 */
const HomeContext = createContext(undefined);
HomeContext.displayName = 'HomeContext';
/**
 * The Category context contains info about the a category. It is set in the category page.
 */
const CategoryContext = createContext(undefined);
CategoryContext.displayName = 'CategoryContext';
export { ArticleContext, ArticleFragmentContext, CategoryContext, HomeContext, RelatedArticlesContext, SearchResultContext, };
//# sourceMappingURL=index.js.map